import { academyAPI } from '../../../../API/academy.api';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { jsPDF } from "jspdf";
import bg from '../../../../../static/img/Training_Course_Certificate.png';
import course from '../../../../../static/img/Course_Completion.png';
import { getNowDate } from '../functions';

export const generateCertificate = (state, intl, user, cb, lists) => {
    const { activeListKey } = state;

    const activelist = lists.filter(item => item.id === activeListKey )[0];

    const name = user.first_name || user.name;

    const text = {
        one: intl.formatMessage({id: "You have completed the training course" , defaultMessage: "You have completed the training course"}),
        two: intl.formatMessage({id: "You have expanded your knowledge and trained your skills in becoming an advanced motorcycle route planner.", defaultMessage: "You have expanded your knowledge and trained your skills in becoming an advanced motorcycle route planner."}),
        founder: intl.formatMessage({id: "Founder of Tourstart" , defaultMessage: "Founder of Tourstart"}),
        certificate: intl.formatMessage({id: "CERTIFICATE" , defaultMessage: "CERTIFICATE"}),
        completion: intl.formatMessage({id: "OF COMPLETION", defaultMessage: "OF COMPLETION" }),
        congratulations: intl.formatMessage({id: "Congratulations", defaultMessage: "Congratulations" }),
        certificateid: intl.formatMessage({id: "Certificate id", defaultMessage: "Certificate id" }),
    }

    const dateString = `${getNowDate().day}/${getNowDate().month} ${getNowDate().year}`

    const doc = new jsPDF('l', 'pt', [3396, 2397],  true);

    //
    const img = new Image();
    img.src = bg;
    doc.addImage(img, 'png', 50, 50, 3300, 2300 );
    //
    const img2 = new Image();
    img2.src = course;
    doc.addImage(img2, 'png', 240, 550, 210, 255);
    //
    doc.saveGraphicsState();
    //
    doc.setGState(new doc.GState({opacity: 0.9}));
    doc.setFillColor(252, 252, 252);
    doc.roundedRect(800, 1040, 1800, 400, 20, 20, 'F');
    //
    doc.setFontSize(65);
    doc.addFont(require('../../../../styles/fonts/MyriadPro-Regular.ttf'), "MyFont", "normal");
    doc.setFont('MyFont');
    doc.text(`${text.one} "${activelist.title}".`, Math.ceil((3396 - doc.getTextWidth(`${text.one} "${activelist.title}".`))/2), 1111 );
    doc.text(text.two, 1696, 1320, {maxWidth: 1750, align: 'center'});
    //
    doc.setFontSize(172);
    doc.text(text.certificate, Math.ceil((3396 - doc.getTextWidth(text.certificate))/2-10), 425);
    //
    doc.setFontSize(90);
    doc.text(text.completion, Math.ceil((3396 - doc.getTextWidth(text.completion))/2), 520);
    //
    doc.setFontSize(65);
    doc.text(text.congratulations, 1000, 770);
    //
    doc.setFontSize(45);
    doc.text(dateString, Math.ceil((3396 - doc.getTextWidth(dateString))/2+630), 1720);
    //
    doc.addFont(require('../../../../styles/fonts/VLADIMIR.ttf'), "Vladimir", "normal");
    doc.setFont('Vladimir');
    doc.setFontSize(188);
    doc.setTextColor(153,41,94);
    doc.text(name, Math.ceil((3396 - doc.getTextWidth(name))/2), 935);
    //
    doc.addFont(require('../../../../styles/fonts/SourceSansPro-Italic.ttf'), "Italic", "normal");
    doc.setFont('Italic');
    doc.setFontSize(42);
    doc.setTextColor(0,0,0)
    doc.text(text.founder, Math.ceil((3396 - doc.getTextWidth(text.founder))/2+850), 1900);
    //
    doc.restoreGraphicsState();
    //

    academyAPI.getId()
    .then(resp => {
        let num = +resp.response + 1;
        doc.setFontSize(42);
        doc.setTextColor(144,144,144);
        doc.text(`${text.certificateid} #${num}`, Math.ceil((3396 - doc.getTextWidth(`${text.certificateid} #${num}`))-200), 2280);

        academyAPI.savePdf(doc.output("blob"))
        .then(res => {
            const {code, response} = res;
            if(code === 200){
                cb(response);
                academyAPI.updateSettingValue(response);
                academyAPI.notificationAfterFinishedCourse(activelist.title);
            }
        })
        .catch(err => console.log(err));
    })
    .catch(err => console.log(err))
}


export const downloadCertificate = (id, title) => window.open(`${process.env.API_URL}/api/academy.getPdf?id=${id}&title=${title}`, '_self');

